/* eslint-disable */
import { motion} from 'framer-motion'
import MetricCard from './MetricsCard';
import { Button } from '@/Components/ui/button';
import { LineChart } from '@/Components/Analytics';
import { Filter, Info, ChevronDown, Trash } from 'lucide-react';
import ParameterSelector from './ParameterSelector';
import { Card } from 'rsuite';
import { modalActions } from '@/Actions';
import { connect } from 'react-redux';
import InfoModal from './infoModal';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/Components/ui/select';
import { Skeleton } from '@mui/material';
import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover';
import moment from 'moment';
import { cn } from '@/lib/utils';

function StatisticalChart(props) {
    const { 
        activeTab,
        parameters,
        handleQualityValueChange,
        qualityValue,
        onFilterButtonClick,
        cardData,
        filteredProducts,
        selectedProduct,
        removeSelectedProduct,
        statisticalGraphData,
        statisticalGraphAnnotations,
        tabVariants,
        fadeVariants,
        statsBoxData,
        toggleInfoModal,
        // new props 
        handleAddTimeFrame,
        handleProductSelection,
        timeFrame,
        setTimeFrame = () => {},
        timeFrameList,
        isCollapsed,
        setIsCollapsed = () => {},
        handleDateChange,
        isLoading,
        } = props;

    return (
        <motion.div
            key='statistical'
            initial='enter'
            animate='center'
            exit='exit'
            variants={tabVariants}
            transition={{ 
                duration: 0.4,
                ease: [0.43, 0.13, 0.23, 0.96]
            }}
            className='flex-1 h-[calc(100vh-8rem)] overflow-hidden'
        >
            <InfoModal />
            <div className='h-full grid grid-cols-2 lg:grid-cols-12 gap-4'>
                {/* Left Sidebar with animation - FIXED WITH SCROLLABLE AREA */}
                <motion.div
                    initial='hidden'
                    animate='visible'
                    variants={fadeVariants}
                    transition={{ 
                        delay: 0.1,
                        duration: 0.5,
                        ease: 'easeInOut'
                    }}
                    className='lg:col-span-3 bg-slate-50 rounded-lg p-4 flex flex-col overflow-hidden'
                >
                    {/* Non-scrollable header section */}
                    <div className='flex-none mb-3'>
                        <div className='flex items-center justify-between'>
                            <span className='text-sm text-slate-600 whitespace-nowrap'>My configuration</span>
                            <Button
                                className='flex items-center gap-2 bg-yellow-500 text-black hover:bg-yellow-600'
                                disabled={cardData.length === 3}
                                onClick={handleAddTimeFrame}
                            >
                                + Add Time Frame
                            </Button>
                        </div>
                    </div>
                    
                    {/* Non-scrollable selection section */}
                    <div className='flex-none mb-3'>
                        <div className='flex flex-col gap-2'>
                            <span className='text-sm text-slate-600'>Selected Products</span>
                            <Select
                                value={selectedProduct}
                                onValueChange={handleProductSelection}
                            >
                                <SelectTrigger >
                                    <SelectValue placeholder='Select Product' />
                                </SelectTrigger>
                                <SelectContent className='w-[245px] overflow-y-auto'>
                                    {filteredProducts && filteredProducts.map(product => (
                                        <SelectItem key={product.id} value={product.id}>
                                            {product.productName}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>
                        
                        <div className='flex flex-col gap-2 mt-3'>
                            <span className='text-sm text-slate-600'>Time Frame</span>
                            <div className='grid grid-cols-4 rounded-md border border-gray-300 w-full'>
                                {timeFrameList.map((item, index) => (
                                    <Button key={index} onClick={() => setTimeFrame(item)} className={`px-2 rounded-md py-2 bg-white text-black hover:bg-slate-800 hover:text-white transition-colors text-[10px] text-center ${timeFrame === item ? 'bg-slate-800 text-white' : ''}`}>
                                        {item}
                                    </Button>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                    {/* Scrollable cards section */}
                    <div className='flex-1 overflow-y-auto pr-1'>
                        <div className='flex flex-col gap-2'>
                            {cardData.map((item, index) => {
                                return (
                                    <div key={index} className={`border-l-4 rounded-md shadow-sm overflow-hidden bg-slate-200`} style={{ borderLeftColor: item.borderColor }}>
                                        <div className='p-2 border-b flex justify-between items-center'>
                                            <span className='text-slate-600 font-medium text-[12px]'>{item.name}</span>
                                            <div className='flex items-center gap-3'>
                                                <Trash onClick={() => removeSelectedProduct(item.id)} className='w-4 h-4 text-slate-600 cursor-pointer' />
                                                <ChevronDown 
                                                    onClick={() => {
                                                        if (isCollapsed && isCollapsed.includes(item.id)) {
                                                            setIsCollapsed(isCollapsed.filter(id => id !== item.id));
                                                        } else {
                                                            setIsCollapsed(isCollapsed ? [...isCollapsed, item.id] : [item.id]);
                                                        }
                                                    }} 
                                                    className={`w-4 h-4 text-slate-600 cursor-pointer transform transition-transform duration-300 ease-in-out ${isCollapsed && isCollapsed.includes(item.id) ? 'rotate-180 translate-y-1 ' : ''}`} 
                                                />
                                            </div>
                                        </div>
                                        <div className='p-2 flex items-center gap-4'>
                                            {isLoading ? (
                                                <Skeleton animation='wave' className='flex-1 h-[50px] border border-white-300 rounded-lg bg-white' />
                                            ) : (
                                                <div className='flex-1 bg-white rounded-md shadow-sm p-2'>
                                                    <div className='flex justify-between items-center'>
                                                        <span className='text-xs text-slate-600'>PP</span>
                                                        <span className='text-green-600 font-bold text-[12px]'>{item.cp}</span>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {isLoading ? (
                                                <Skeleton animation='wave' className='flex-1 h-[50px] border border-white-300 rounded-lg bg-white' />
                                            ) : (
                                                <div className='flex-1 bg-white rounded-md shadow-sm p-2'>
                                                    <div className='flex justify-between items-center'>
                                                        <span className='text-xs text-slate-600'>PPK</span>
                                                        <span className='text-red-500 font-bold text-[12px]'>{item.cpk}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className={cn(
                                            'transition-all duration-300 ease-in-out overflow-hidden',
                                            isCollapsed && isCollapsed.includes(item.id) ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                                        )}>
                                            <div className='p-2 grid grid-cols-2 gap-y-2 gap-x-2'>
                                                <div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
                                                    <span className='text-xs text-slate-600 '>Total</span>
                                                    <span className='text-sm text-slate-600 font-semibold'>{item.total}</span>
                                                </div>
                                                <div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
                                                    <span className='text-xs text-slate-600 '>Pass %</span>
                                                    <span className='text-sm text-slate-600 font-semibold'>{item.passPercent}%</span>
                                                </div>
                                                <div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
                                                    <span className='text-xs text-slate-600 '>LSL</span>
                                                    <span className='text-sm text-slate-600 font-semibold'>{item.lsl}</span>
                                                </div>
                                                <div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
                                                    <span className='text-xs text-slate-600 '>Mean</span>
                                                    <span className='text-sm text-slate-600 font-semibold'>{item.mean}</span>
                                                </div>
                                                <div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
                                                    <span className='text-xs text-slate-600 '>USL</span>
                                                    <span className='text-sm text-slate-600 font-semibold'>{item.usl}</span>
                                                </div>
                                                <div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
                                                    <span className='text-xs text-slate-600 '>Standard Deviation (σ)</span>
                                                    <span className='text-sm text-slate-600 font-semibold'>{item.standardDeviation}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='p-2 '>
                                            <div className='flex items-center justify-between mb-2 pt-2' style={{ borderTop: '1px solid rgba(0, 0, 0, 0.15)' }}>
                                                <span className='text-[12px] text-slate-600'>Time frame</span>
                                                <Popover>
                                                    <PopoverTrigger asChild>
                                                        <span className='bg-slate-300 text-[10px] px-2 py-1 rounded cursor-pointer'>
                                                            {item.timeFrame.timeType === 'daily' || item.timeFrame.timeType === 'yearly' ? (
                                                                moment(item.timeFrame.value).format('MMM D YYYY')
                                                            ) : (
                                                                Array.isArray(item.timeFrame.value) ? 
                                                                    `${moment(item.timeFrame.value[0]).format('MMM D YYYY')} - ${moment(item.timeFrame.value[1]).format('MMM D YYYY')}` :
                                                                    `${moment(item.timeFrame.value.startDate).format('MMM D YYYY')} - ${moment(item.timeFrame.value.endDate).format('MMM D YYYY')}`
                                                            )}
                                                        </span>
                                                    </PopoverTrigger>
                                                    <PopoverContent 
                                                        className='w-auto p-0' 
                                                        align='start' 
                                                        side='top'
                                                        sideOffset={5}
                                                    >
                                                        {React.cloneElement(item.timeFrame.component, {
                                                            onChange: (value) => {
                                                                handleDateChange(item.id, value);
                                                            },
                                                            value: item.timeFrame.value,
                                                        })}
                                                    </PopoverContent>
                                                </Popover>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </motion.div>

                {/* Main Content with animation */}
                <motion.div
                    initial='hidden'
                    animate='visible'
                    variants={fadeVariants}
                    transition={{ 
                        delay: 0.2,
                        duration: 0.5,
                        ease: 'easeInOut'
                    }}
                    className='lg:col-span-9 flex flex-col'
                >
                    <div className='flex justify-between items-center p-4 bg-white z-10 rounded-lg mb-4'>
                        <div className='flex items-center gap-2'>
                            <span className='text-sm font-medium'>Select Parameter</span>
                            <div className='relative w-[300px]'>
                                <ParameterSelector 
                                    parameters={parameters} 
                                    handleQualityValueChange={handleQualityValueChange}
                                    qualityValue={qualityValue}
                                    tabType={activeTab}
                                />
                            </div>
                        </div>
                        <div className='flex items-center gap-2'>
                            <Button 
                                variant='outline' 
                                className='flex items-center gap-2'
                                onClick={() => toggleInfoModal(true)}
                            >
                                <Info className='h-4 w-4'/> 
                                Info 
                            </Button>
                            <Button
                                variant='outline'
                                onClick={onFilterButtonClick}
                                className='flex items-center gap-2 bg-[#0D9488] text-white hover:bg-[#0B7C73]'
                            >
                                <Filter className='h-4 w-4' />
                                <span>Filter</span>
                            </Button>
                        </div>
                    </div>

                    <div className='flex-1 overflow-auto'>
                        <div className={cn(
                            'grid gap-4 mb-4',
                            statsBoxData?.length === 1 ? 'grid-cols-1' : 
                            statsBoxData?.length === 2 ? 'grid-cols-2' :
                            statsBoxData?.length === 3 ? 'grid-cols-3' :
                            statsBoxData?.length === 4 ? 'grid-cols-4' :
                            'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
                        )}>
                            {(statsBoxData || []).map((key) => (
                                <MetricCard 
                                    key={key?.label || Math.random()} 
                                    data={key}
                                    tabType='stats'
                                />
                            ))}
                        </div>
                        <div className='h-[calc(100vh-22rem)] w-full'>
                            <LineChart
                                data={statisticalGraphData}
                                annotations={statisticalGraphAnnotations}
                                legendDisplay={true}
                                xScale={{
                                    type: 'linear',
                                }}
                            />
                        </div>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    )}

const mapStateToProps = (state) => {
    const { show, data } = state.modal.infoModal || { show: false, data: null };
        return {
            show,
            data,
        };
    };

const mapDispatchToProps = {
    toggleInfoModal: modalActions.toggleInfoModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticalChart);